import actions from "@/store/category/actions";
import state from "@/store/category/states";
import mutations from "@/store/category/mutations";

const CategoryModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default CategoryModule;